export const pageUrls = {
  msite: {
    earlyAceess: '/plp/banner/earlyaccess',
    searchPage: '/shop/search'
  },
  msiteLuxe: {
    searchPage: '/shop/LuxeSearch'
  },
  desktop: {
    earlyAceess: '/plp/banner/earlyaccess'
  },
  desktopLuxe: {}
};
